'use client';

import { Notification } from '@packages/shared/src/ui/Notification/Notification';
import { useIntl } from 'react-intl';

export type InstallmentCalculatorErrorFallbackProps = {
  onCloseHandler?(): void;
};

export const InstallmentCalculatorErrorFallback = ({
  onCloseHandler,
}: InstallmentCalculatorErrorFallbackProps) => {
  const { formatMessage } = useIntl();

  return (
    <Notification onClose={onCloseHandler} severity="warning">
      {formatMessage({
        id: 'ic-errorFallback-message',
        defaultMessage:
          'Aus technischen Gründen ist die Berechnung der Rate momentan nicht möglich. Bitte lade die Seite erneut oder versuche es später noch einmal.',
      })}
    </Notification>
  );
};
